import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseService } from 'src/app/core/models/response-service.model';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class CalendarService {
	constructor(private http: HttpClient, private utils: UtilsService) {}

	// public get_calendar_leads_by_user(userId: number, dateStart:string, dateEnd:string){

	//   if (dateStart==""){
	//     dateStart = "-";
	//   }
	//   if (dateEnd==""){
	//     dateEnd = "-";
	//   }

	//   const url = `${environment.api}lead/get_calendar_leads_user/${userId}/${dateStart}/${dateEnd}`;
	//   return this.http.get(url);
	// }

	getCampaignMonthLeads(payload: any) {
		const url = `${environment.api}calendar/get_campaign_month_leads`;
		const formData = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	// TODO: ENDPOINT NO USADO
	public get_calendar_leads_by_user(userId: number, dateStart: string, dateEnd: string) {
		if (dateStart == '') {
			dateStart = '-';
		}
		if (dateEnd == '') {
			dateEnd = '-';
		}

		return this.http.get(`${environment.api}lead/get_calendar_leads_user/${userId}/${dateStart}/${dateEnd}`);
	}
}
